export default {
  pageTitle: {
    id: 'bo_seller.kyb.beneficial_owner.page_title',
    defaultMessage: 'KYB - Beneficial owner details',
  },
  title: {
    id: 'bo_seller.kyb.beneficial_owner.title',
    defaultMessage: 'Primary beneficial owner details',
  },
  description: {
    id: 'bo_seller.kyb.beneficial_owner.description',
    defaultMessage:
      "Fill out details for the business's primary beneficial owner or the majority shareholder. If the majority shareholder is a business, add the director, CEO, or CFO of that business. You can add up to 5 beneficial owners if you want to include additional owners.",
  },
  loadingBeneficialOwnerDetails: {
    id: 'bo_seller.kyb.beneficial_owner.loading_beneficial_owner_details',
    defaultMessage: 'Loading beneficial owner details...',
  },
  savingBeneficialOwnerDetails: {
    id: 'bo_seller.kyb.beneficial_owner.saving_beneficial_owner_details',
    defaultMessage: 'Saving beneficial owner details...',
  },
  primaryBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.primary_beneficial_owner',
    defaultMessage: 'Primary beneficial owner',
  },
  sameAsAccountRequesterLabel: {
    id: 'bo_seller.kyb.beneficial_owner.same_as_account_requester',
    defaultMessage:
      'Check this box if the primary beneficial owner is also the account requester.',
  },
  sameAsLegalRepresentativeLabel: {
    id: 'bo_seller.kyb.beneficial_owner.same_as_legal_representative',
    defaultMessage:
      'Check this box if the primary beneficial owner is also the legal representative.',
  },
  additionalBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.additional_beneficial_owner',
    defaultMessage: 'Additional beneficial owner',
  },
  addBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.add_beneficial_owner',
    defaultMessage: 'Add beneficial owner',
  },
  removeBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.remove_beneficial_owner',
    defaultMessage: 'Remove',
  },
  saveButton: {
    id: 'bo_seller.kyb.beneficial_owner.save_button',
    defaultMessage: 'Save',
  },
  saveSuccessTitle: {
    id: 'bo_seller.kyb.beneficial_owner.save_success_title',
    defaultMessage: 'Beneficial owners have been saved successfully.',
  },
  saveSuccessContent: {
    id: 'bo_seller.kyb.beneficial_owner.save_success_content',
    defaultMessage: 'Nice work.',
  },
  saveErrorTitle: {
    id: 'bo_seller.kyb.beneficial_owner.save_error_title',
    defaultMessage: 'Error',
  },
} as const
